import type { PricingTier } from '@estac1/shared';

export const SAMPLE_VACANCIES = [1, 10, 30, 80, 150] as const;

export const formatAt = (raw: string) =>
  new Date(raw).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export const validate = (input: {
  tiers: PricingTier[];
  minimumCents: number;
  maxVacancies: number;
  trialDays: number;
}): string | null => {
  if (input.tiers.length === 0) return 'Defina ao menos uma faixa.';
  if (input.minimumCents <= 0) return 'Piso mensal precisa ser maior que zero.';
  if (input.maxVacancies <= 0) return 'Limite máximo de vagas precisa ser positivo.';
  if (input.trialDays < 0) return 'Dias de teste não podem ser negativos.';

  const sorted = [...input.tiers].sort((a, b) => a.minVacancies - b.minVacancies);
  for (let i = 0; i < sorted.length; i++) {
    const tier = sorted[i] as PricingTier;
    if (tier.minVacancies <= 0) return `Tier ${i + 1}: mínimo deve ser positivo.`;
    if (tier.maxVacancies < tier.minVacancies)
      return `Tier ${i + 1}: máximo (${tier.maxVacancies}) não pode ser menor que mínimo (${tier.minVacancies}).`;
    if (tier.monthlyCents <= 0) return `Faixa ${i + 1}: mensalidade precisa ser maior que zero.`;
    if (i > 0) {
      const prev = sorted[i - 1] as PricingTier;
      if (tier.minVacancies !== prev.maxVacancies + 1) {
        return `Tier ${i + 1} deveria começar em ${prev.maxVacancies + 1} para ficar contíguo ao anterior.`;
      }
    }
  }
  const last = sorted[sorted.length - 1] as PricingTier;
  if (last.maxVacancies !== input.maxVacancies) {
    return `Último tier termina em ${last.maxVacancies}, mas o limite máximo é ${input.maxVacancies}. Alinhe os dois.`;
  }
  return null;
};
